import React from 'react'
import MediaQuery from 'react-responsive'

import { Footnote, Heading2, Spinner } from '@acorns/web-components'
import { useRemoteStrings } from '@acorns/web-utils'
import styled from 'styled-components'

import Container from 'components/Layout'
import { MobileFootnote } from 'components/MobileFootnote'
import Nav from 'components/Nav'
import themeValues, { style } from 'theme'

type FlowProps = {
  isAddingBitcoin?: boolean
}

const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 165px;
  @media screen and (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    padding: 35px 30px 0px;
    margin-top: 0px;
    position: absolute;
    top: 70px;
    left: 0px;
    width: 100vw;
    height: calc(100vh - 100px);
  }
`

const StyledFootnote = styled(Footnote)`
  font-style: italic;
  margin-top: 185px;
  margin-bottom: 0px;
  text-align: center;
  @media screen and (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    position: absolute;
    bottom: 0;
    margin-left: 30px;
    margin-right: 30px;
  }
`

const StyledSpinner = styled(Spinner)`
  margin-bottom: 26px;
`

const StyledSpinnerContainer = styled.div`
  position: absolute;
  top: 40%;
`

const CalculatingPortfolioLoading = (props: FlowProps) => {
  const { getRemoteString } = useRemoteStrings()

  return (
    <>
      <Nav hideProgressBar={true} title="Calculating Portfolio" />
      <MediaQuery maxWidth={themeValues.breakpoints.sm}>
        <Content>
          <StyledSpinnerContainer>
            <StyledSpinner />
          </StyledSpinnerContainer>
          <Heading2>
            {props.isAddingBitcoin
              ? getRemoteString({ key: 'invest.new_etf.lander.loading.label' })
              : getRemoteString({ key: 'portfolio_theme.calculating.title' })}
          </Heading2>
        </Content>
        <MobileFootnote>
          {!props.isAddingBitcoin &&
            getRemoteString({ key: 'invest.onboarding.portfolio_animation.loading.footnote' })}
        </MobileFootnote>
      </MediaQuery>
      <MediaQuery minWidth={themeValues.breakpoints.sm + 1}>
        <Container>
          <Content>
            <StyledSpinner />
            <Heading2>
              {props.isAddingBitcoin
                ? getRemoteString({ key: 'invest.new_etf.lander.loading.label' })
                : getRemoteString({ key: 'portfolio_theme.calculating.title' })}
            </Heading2>
            <StyledFootnote>
              {!props.isAddingBitcoin &&
                getRemoteString({ key: 'invest.onboarding.portfolio_animation.loading.footnote' })}
            </StyledFootnote>
          </Content>
        </Container>
      </MediaQuery>
    </>
  )
}

export { CalculatingPortfolioLoading }
